export const HR_EMPLOYEES = '/hr/Employees'

export const HR_EMPLOYEES_IMPORT_TEMPLATE = `${HR_EMPLOYEES}/import-template`

export const HR_EMPLOYEES_IMPORT = `${HR_EMPLOYEES}/import`

export const HR_EMPLOYEES_ME = `${HR_EMPLOYEES}/me`

export const HR_EMPLOYEES_APPLICANTS = `${HR_EMPLOYEES}/applicants`

export const HR_EMPLOYEES_UNEVALUATED = `${HR_EMPLOYEES}/unevaluated`

export function hrEmployeeById(id: number) {
  return `${HR_EMPLOYEES}/${id}`
}

export function hrEmployeeApplicantRequestStatus(id: number) {
  return `${HR_EMPLOYEES}/${id}/applicants/request-status`
}

export function hrEmployeeStatus(id: number) {
  return `${HR_EMPLOYEES}/${id}/status`
}

export const HR_EMPLOYEE_PERSONAL_INFO = `${HR_EMPLOYEES}/personal-info`

export const HR_EMPLOYEE_IDENTITY_INFO = `${HR_EMPLOYEES}/identity-info`

export const HR_EMPLOYEE_FAMILY_INFO = `${HR_EMPLOYEES}/family-info`

export const HR_EMPLOYEE_MILITARY_SERVICE_INFO = `${HR_EMPLOYEES}/military-service-info`

export const HR_EMPLOYEE_EDUCATIONAL_INFO = `${HR_EMPLOYEES}/educational-info`

export const HR_EMPLOYEE_WORK_EXPERIENCE_INFO = `${HR_EMPLOYEES}/work-experience-info`

export function hrEmployeeForms(id: number) {
  return `${HR_EMPLOYEES}/${id}/forms`
}

export const HR_POSITIONS = '/hr/Positions'

export const HR_POSITIONS_LOOKUP = `${HR_POSITIONS}/lookup`

export const HR_POSITIONS_EMPLOYEES = `${HR_POSITIONS}/employees`

export function hrPositionById(id: number) {
  return `${HR_POSITIONS}/${id}`
}

export const SHOP_PROVINCES = '/shop/Provinces'

export function shopProvinceCities(provinceId: number) {
  return `${SHOP_PROVINCES}/${provinceId}/cities`
}
